// extracted by mini-css-extract-plugin
export var container = "_jf-0";
export var dotAnimation = "_jf-2";
export var dotsLoading = "_jf-1";